import { Avatar, Box, Typography } from "@mui/material"
import { useContext, useState } from "react"
import { NotesContext, TPrevNoteList } from "../NotesModuleContext"
import { COLORS } from "@/theme/localTheme"
import dayjs from "dayjs"
import ImagePreview from "@/components/layout-components/ImagePreview"
import styles from "./PreviousNotes.module.css"
import CustomAvatar from "@/components/field-components/CustomAvatar"
import noResults from "../../../utils/assets/images/No Results.svg"
import { TImageModal } from "../../../../interface/ImagePreview"
import { responseToImagePreview } from "@/utils/CommonFunctions"

const PreviousNotes = () => {
  const { previousNotes } = useContext(NotesContext)

  const { data: PrevNotesList } = previousNotes as any

  const [prevImage, setPrevImage] = useState<TImageModal>({ isOpen: false, images: [], startIndex: 0 })

  const handleOpenImagePreview = (images: Array<any>, index: number) => {
    const imageList = images.map(responseToImagePreview)
    setPrevImage({
      isOpen: true,
      images: imageList,
      startIndex: index,
    })
  }

  const handleCloseImagePreview = () => {
    setPrevImage({
      isOpen: false,
      images: [],
      startIndex: 0,
    })
  }

  function getFullName(firstName: string | undefined, lastName: string | undefined) {
    if (!firstName && !lastName) {
      return "System Generated"
    } else if (!firstName) {
      return lastName
    } else if (!lastName) {
      return firstName
    } else {
      return `${firstName} ${lastName}`
    }
  }

  return (
    <Box className={styles.PrevNotesSection}>
      <Box className={styles.Header}>
        <Box className={styles.Title}>Notes Log</Box>
        <Box className={styles.NotesMeta}>
          <Box className={styles.NotesCountLabel}>NOTE COUNT -</Box>
          <Typography
            className={styles.NotesCountValue}
            sx={{
              background: COLORS?.adminAppOutlineColor,
            }}
            data-overflow={PrevNotesList?.length > 99}
          >
            {PrevNotesList?.length}
          </Typography>
        </Box>
      </Box>
      <Box className={styles.NotesList}>
        {PrevNotesList?.length > 0 ? (
          <>
            {PrevNotesList.map((data: TPrevNoteList, index: number) => {
              const notesImages = data.images || []

              const fullName = getFullName(data?.user?.first_name, data?.user?.last_name)
              return (
                <Box key={`PrevNotes_${index}`} className={styles.ListItem}>
                  <CustomAvatar name={fullName} width={30} height={30} fontSize={14} />
                  <Box className={styles.Content}>
                    <Box className={styles.BasicInfo}>
                      {fullName && <Typography className={styles.Name}>{fullName}</Typography>}
                      <Typography className={styles.Time}>{dayjs(data.created_at, { locale: "en" }).format("DD-MM-YYYY hh:mm A")}</Typography>
                    </Box>
                    <Typography className={styles.Notes}> {data.notes ?? data.Note} </Typography>
                    <Box className={styles.ImageList}>
                      {notesImages.length >= 1 &&
                        notesImages.map((noteImg: any, imgIndex: number) => (
                          <Box className={styles.ImageItem} style={{ position: "relative" }} key={`Attachments_${index}_${imgIndex}`}>
                            <img
                              src={noteImg.url}
                              width="50px"
                              height="50px"
                              style={{ borderRadius: "5px" }}
                              alt={`${noteImg.name}`}
                              onClick={() => handleOpenImagePreview(notesImages, imgIndex)}
                            />
                          </Box>
                        ))}
                    </Box>
                  </Box>
                </Box>
              )
            })}
          </>
        ) : (
          <Box className={styles.NoItems}>
            <img src={noResults.src} alt="empty-cart" width="150px" height="150px" />
            <Box>No Notes Log Found</Box>
          </Box>
        )}
      </Box>
      <ImagePreview startIndex={prevImage.startIndex} images={prevImage.images} isOpen={prevImage.isOpen} onClose={handleCloseImagePreview} />
    </Box>
  )
}

export default PreviousNotes
